import useReveal from "@/hooks/useReveal";

const LIFESTYLE = [
  {
    src: "https://customer-assets.emergentagent.com/job_afrqa-luxury/artifacts/0esx8z7g_fcda3137-3915-43e7-b3f9-6b5055ad7dbd.JPG",
    caption: "Vol. I · The Africa Frame™",
    sub: "Edition 001",
    span: "lg:col-span-7 aspect-[5/6] lg:aspect-auto lg:row-span-2",
    bg: "bg-[#0c0c0c]",
    real: true,
  },
  {
    src: "https://customer-assets.emergentagent.com/job_afrqa-luxury/artifacts/pqgm23us_afrqa%20model%203.PNG",
    caption: "Rooftop · Golden Hour",
    sub: "Campaign · Vol. I",
    span: "lg:col-span-5 aspect-[4/5]",
    bg: "bg-[#0c0c0c]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_afrqa-luxury/artifacts/x1soojwk_c8096233-b39b-44e4-b5ab-6e375337c685.JPG",
    caption: "Detail · Side Profile",
    sub: "Real prototype · Gold-tone",
    span: "lg:col-span-5 aspect-[5/4]",
    bg: "bg-[#0c0c0c]",
    real: true,
  },
];

export default function Lifestyle() {
  const r = useReveal();
  return (
    <section
      data-testid="lifestyle-section"
      className="relative bg-[#0a0a0a] py-24 md:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div
          ref={r.ref}
          className={`reveal ${r.inView ? "in-view" : ""} mb-14 max-w-2xl`}
        >
          <span className="font-label text-[#d4af37]">— The Editorial —</span>
          <h2 className="mt-4 font-display text-[clamp(1.8rem,4vw,3.4rem)] leading-tight text-white">
            Worn by those who design{" "}
            <span className="font-editorial italic gold-text-gradient">
              their own legacy.
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {LIFESTYLE.map((item, i) => (
            <figure
              key={i}
              className={`relative zoom-wrap ${item.real ? "prototype-photo" : ""} ${item.bg} border border-[#1f1f1f] ${item.span}`}
              data-testid={`lifestyle-${i}`}
            >
              <img
                src={item.src}
                alt={item.caption}
                className="w-full h-full object-cover"
              />
              {item.real && (
                <span
                  aria-hidden
                  className="absolute inset-0 pointer-events-none"
                  style={{
                    background:
                      "radial-gradient(ellipse at center, transparent 55%, rgba(0,0,0,0.40) 100%)",
                  }}
                />
              )}
              {/* Bottom gradient for caption legibility */}
              <span
                aria-hidden
                className="absolute inset-x-0 bottom-0 h-1/3 pointer-events-none"
                style={{
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 100%)",
                }}
              />
              <figcaption className="absolute bottom-5 left-5 right-5 flex items-end justify-between gap-3">
                <div>
                  <span className="font-label text-[#e6d5b8] block">
                    {item.caption}
                  </span>
                  {item.sub && (
                    <span className="font-editorial italic text-[#cfcfca] text-sm mt-1 block">
                      {item.sub}
                    </span>
                  )}
                </div>
                {item.real && (
                  <span className="font-label text-[#d4af37] text-[10px]">
                    Real prototype
                  </span>
                )}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
